<template>
    <div class="image-clip">
        <div @mousedown="dragStart" @mouseup="dragEnd" @mousemove="dragging" @mouseleave="dragEnd" ref="container" class="clip-container">
            <div ref="clipT" class="clip-box top"></div>
            <div ref="clipTR" class="clip-box top-right"></div>
            <div ref="clipR" class="clip-box right"></div>
            <div ref="clipRB" class="clip-box right-bottom"></div>
            <div ref="clipB" class="clip-box bottom"></div>
            <div ref="clipBL" class="clip-box bottom-left"></div>
            <div ref="clipL" class="clip-box left"></div>
            <div ref="clipLT" class="clip-box left-top"></div>
            <div ref="dotTL" @mousedown="dragDotStart('TL')" class="drag-dot t-l"></div>
            <div ref="dotTR" @mousedown="dragDotStart('TR')" class="drag-dot t-r"></div>
            <div ref="dotBL" @mousedown="dragDotStart('BL')" class="drag-dot b-l"></div>
            <div ref="dotBR" @mousedown="dragDotStart('BR')" class="drag-dot b-r"></div>
        </div>
        <canvas ref="previewCanvas" :width="previewBox.width" :height="previewBox.height" class="preview-box"></canvas>
        <div style="text-align: center;margin-top: 20px;">
            <btn :type="1" info="重新选择" @click="chooseAnotherImage"></btn>
            <btn :type="0" info="确定" style="margin-left: 8px;" @click="ok"></btn>
        </div>
    </div>
</template>
<script>
import Btn from './Button' 
export default {
    props: {
        imageDataUrl: {
            type: String,
            default: ''
        },
        shearRatio: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Btn
    },
    data() {
        return {
            container: {
                width: 380,
                height: 380
            },
            previewBox: {
                width: 380,
                height: 380
            },
            clipBox: {
                width: 180,
                height: 180
            },
            // 图片缩小比例
            imageScaleRatio: 1,
            // 截图框尺寸
            clwidth: 0,
            clheight: 0,
            // 截图框中心点坐标
            clcenterx: 0,
            clcentery: 0,
            // 截图框起始中心点坐标
            clcenterstartx: 0,
            clcenterstarty: 0,
            isDragging: false,
            // 图片在画布中起始坐标
            x: 0,
            y: 0,
            // 拖动起始坐标
            dragStartX: 0,
            dragStartY: 0,
            // 最终图片画出来的尺寸
            dwidth: 0,
            dheight: 0,
            previewCtx: null,
            image: null,
            clipT: null,
            clipTR: null,
            clipR: null,
            clipRB: null,
            clipB: null,
            clipBL: null,
            clipL: null,
            clipLT: null,
            // clipBoxPropertyList: [
            //     ['left'],
            //     [],
            //     ['top'],
            //     [],
            //     ['left'],
            //     [],
            //     ['top'],
            //     [],
            // ],
            clipBoxList: ['clipT', 'clipTR', 'clipR', 'clipRB', 'clipB', 'clipBL', 'clipL', 'clipLT'],
            topLeftDot: null,
            topRightDot: null,
            bottomLeftDot: null,
            bottomRightDot: null,
            // distance: [],
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            dotTL: null,
            dotTR: null,
            dotBL: null,
            dotBR: null,
            moveDistanceVertical: 0,
            moveDistanceHorizontal: 0,
            isDotdragging: false,
            dragDotType: '',
            initLeft: 0,
            initTop: 0,
            initRight: 0,
            initBottom: 0
        }
    },
    watch: {
        imageDataUrl() {
            this.initContainer();
        }
    },
    methods: {
        initContainer() {
            this.image = new Image();
            this.image.src = this.imageDataUrl;
            let previewCanvas = this.$refs.previewCanvas;
            this.previewCtx = previewCanvas.getContext('2d');
            this.image.onload = () => {
                this.caculate(this.container, this.image);
                let dwidth = this.dwidth;
                let dheight = this.dheight;
                let x = this.x;
                let y = this.y;
                // 图片作为容器背景图 
                this.$refs.container.style.background = `url(${this.imageDataUrl}) center / ${dwidth}px ${dheight}px no-repeat`;
                this.$refs.container.style.width = `${this.container.width}px`;
                this.$refs.container.style.height = `${this.container.height}px`;

                // 剪裁区域初始化
                this.clwidth = Math.round(this.imageScaleRatio * this.clipBox.width);
                this.clheight = Math.round(this.imageScaleRatio * this.clipBox.height);
                this.clcenterx = this.container.width / 2;
                this.clcentery = this.container.height / 2;
                this.clcenterstartx = this.clcenterx;
                this.clcenterstarty = this.clcentery;

                this.clipBoxList.forEach(box => {
                    this[box] = this.$refs[box];
                });

                this.dotTL = this.$refs.dotTL;
                this.dotTR = this.$refs.dotTR;
                this.dotBL = this.$refs.dotBL;
                this.dotBR = this.$refs.dotBR;

                this.moveDistanceHorizontal = parseInt(window.getComputedStyle(this.dotTL, null).width) / 2; 
                this.moveDistanceVertical = parseInt(window.getComputedStyle(this.dotTL, null).height) / 2;

                this.top = Math.round(this.clcentery - this.clheight / 2);
                this.right = Math.round(this.clcenterx + this.clwidth / 2);
                this.bottom = Math.round(this.clcentery + this.clheight / 2);
                this.left = Math.round(this.clcenterx - this.clwidth / 2);

                this.moveClipBox();
            }
        },
        moveClipBox() {
            
            this.clipT.style.left = `${this.left}px`;
            this.clipT.style.width = `${this.clwidth}px`;
            this.clipT.style.height = `${this.top}px`;

            this.clipTR.style.height = `${this.top}px`;
            this.clipTR.style.width = `${this.container.width - this.right}px`;

            this.clipR.style.top = `${this.top}px`;
            this.clipR.style.width = `${this.container.width - this.right}px`;
            this.clipR.style.height = `${this.clheight}px`;

            this.clipRB.style.width = `${this.container.width - this.right}px`;
            this.clipRB.style.height = `${this.container.height - this.bottom}px`;

            this.clipB.style.left = `${this.left}px`;
            this.clipB.style.width = `${this.clwidth}px`;
            this.clipB.style.height = `${this.container.height - this.bottom}px`;

            this.clipBL.style.width = `${this.left}px`;
            this.clipBL.style.height = `${this.container.height - this.bottom}px`;

            this.clipL.style.top = `${this.top}px`;
            this.clipL.style.width = `${this.left}px`;
            this.clipL.style.height = `${this.clheight}px`;

            this.clipLT.style.width = `${this.left}px`;
            this.clipLT.style.height = `${this.top}px`;

            this.dotTL.style.left = `${this.left - this.moveDistanceHorizontal}px`;
            this.dotTL.style.top = `${this.top - this.moveDistanceVertical}px`;

            this.dotTR.style.left = `${this.right - this.moveDistanceHorizontal}px`;
            this.dotTR.style.top = `${this.top - this.moveDistanceVertical}px`;

            this.dotBL.style.left = `${this.left - this.moveDistanceHorizontal}px`;
            this.dotBL.style.top = `${this.bottom - this.moveDistanceVertical}px`;

            this.dotBR.style.left = `${this.right - this.moveDistanceHorizontal}px`;
            this.dotBR.style.top = `${this.bottom - this.moveDistanceVertical}px`;

            this.drawPreviewImg();
        },
        drawPreviewImg() {
            this.previewCtx.clearRect(0, 0, this.previewBox.width, this.previewBox.height);
            this.previewCtx.beginPath();
            this.previewCtx.drawImage(
                this.image, 
                ( this.clcenterx - this.clwidth / 2 - this.container.width / 2 + this.dwidth / 2) / this.imageScaleRatio,
                ( this.clcentery - this.clheight / 2 - this.container.height / 2 + this.dheight / 2) / this.imageScaleRatio,
                this.clwidth / this.imageScaleRatio,
                this.clheight / this.imageScaleRatio,
                0,
                0,
                this.clwidth,
                this.clheight
            );
        },
        caculate(container, image) {
            let cwidth = container.width;
            let cheight = container.height;
            let iwidth = image.width;
            let iheight = image.height;
            let dwidth = 0;
            let dheight = 0;
            let x = 0;
            let y = 0;
            // 当图片本身的尺寸小于画布的尺寸时图片保持原尺寸
            if (iwidth < cwidth && iheight < cheight) {
                dwidth = iwidth;
                dheight = iheight;
            } else {
                if (iwidth / iheight > cwidth / cheight) {
                    dwidth = cwidth;
                    dheight = Math.round(dwidth * iheight / iwidth);
                } else {
                    dheight = cheight;
                    dwidth = Math.round(dheight * iwidth / iheight);
                }
            }
            this.x = Math.round((cwidth - dwidth) / 2);
            this.y = Math.round((cheight - dheight) / 2);
            this.dwidth = dwidth;
            this.dheight = dheight;
            this.imageScaleRatio = dwidth / iwidth;
        },
        dragStart(e) {
            e.preventDefault()
            // 判断点击区域在截图区域内 
            if (this.isDragging) 
                return;
            if (this.clipType === 1) {
                if (Math.pow(e.offsetX - this.clcenterx, 2) + Math.pow(e.offsetY - this.clcentery, 2) <= Math.pow(this.clwidth / 2, 2)) {
                    this.isDragging = true;
                }
            } else {
                if (Math.abs(e.offsetX - this.clcenterx) < this.clwidth / 2 && Math.abs(e.offsetY - this.clcentery) < this.clheight / 2) {
                    this.isDragging = true;
                }
            }
            this.dragStartX = e.clientX;
            this.dragStartY = e.clientY;

            // 每次初始化中心点起始坐标 
            this.clcenterstartx = this.clcenterx;
            this.clcenterstarty = this.clcentery;
        },
        dragging(e) {
            document.addEventListener("mousemove",function(){
                event.preventDefault();
            },{ passive: false });
            if (this.isDotdragging && this.checkClipBoxSize(this.dragDotType, event.clientX)) {
                requestAnimationFrame(this.moveClipBox);
            } else if (this.isDragging && this.checkInside(e.clientX, e.clientY)) {
                requestAnimationFrame(this.moveClipBox);
            }
        },
        dragEnd() {
            this.isDragging = false;
            this.isDotdragging = false;
        },
        dragDotStart(type) {

            this.dragStartX = event.clientX;

            this.initLeft = this.left;
            this.initTop = this.top;
            this.initRight = this.right;
            this.initBottom = this.bottom;

            this.isDotdragging = true;
            this.dragDotType = type;
        },
        checkInside(clientX, clientY) {
            let clcenterx = clientX - this.dragStartX + this.clcenterstartx;
            let clcentery = clientY - this.dragStartY + this.clcenterstarty;
            let leftTopX = Math.round(this.x + this.clwidth / 2);
            let leftTopY = Math.round(this.y + this.clheight / 2);
            let rightBottomX = Math.round(this.x + this.dwidth - this.clwidth / 2);
            let rightBottomY = Math.round(this.y + this.dheight - this.clheight / 2);
            if (clcenterx > leftTopX && clcenterx < rightBottomX && clcentery > leftTopY && clcentery < rightBottomY) {
                this.clcenterx = clcenterx;
                this.clcentery = clcentery;

                this.top = Math.round(this.clcentery - this.clheight / 2);
                this.right = Math.round(this.clcenterx + this.clwidth / 2);
                this.bottom = Math.round(this.clcentery + this.clheight / 2);
                this.left = Math.round(this.clcenterx - this.clwidth / 2);
                return true;
            }
            return false;
        },
        checkClipBoxSize(type, clientX) {
            let moveDistanceHorizontal = Math.round(clientX - this.dragStartX);
            let changeKeyX = '';
            let changeKeyY = '';
            let widthAfterMove = 0;
            let heightAfterMove = 0;
            let obj = {
                top: this.initTop,
                right: this.initRight,
                left: this.initLeft,
                bottom: this.initBottom
            };
            let temp;
            switch (type) {
                case 'TL': 
                    changeKeyX = 'left';
                    changeKeyY = 'top';
                    break;
                case 'TR' : 
                    changeKeyX = 'right';
                    changeKeyY = 'top';
                    break;
                case 'BL' :
                    changeKeyX = 'left';
                    changeKeyY = 'bottom';
                    break;
                default:
                    changeKeyX = 'right';
                    changeKeyY = 'bottom';
            }

            obj[changeKeyX] += moveDistanceHorizontal;
            temp = Math.round(moveDistanceHorizontal * this.clipBox.height / this.clipBox.width);
            obj[changeKeyY] = obj[changeKeyY] + (type === 'TR' || type === 'BL' ? -temp : temp);

            widthAfterMove = Math.round((obj.right - obj.left) / this.imageScaleRatio);
            heightAfterMove = Math.round((obj.bottom - obj.top) / this.imageScaleRatio);

            if (widthAfterMove > this.clipBox.width
            && heightAfterMove > this.clipBox.height
            && obj.left > this.x
            && obj.right < (this.x + this.dwidth)
            && obj.top > this.y
            && obj.bottom < (this.y + this.dheight)) {
                this.top = obj.top;
                this.left = obj.left;
                this.right = obj.right;
                this.bottom = obj.bottom;
                this.clcenterx = Math.round((this.left + this.right) / 2);
                this.clcentery = Math.round((this.top + this.bottom) / 2);
                this.clwidth = Math.round(this.right - this.left);
                this.clheight = Math.round(this.bottom - this.top);
                return true;
            }
            return false;
        },
        getFinalSize() {
            let obj = {};
            obj.x = Math.round((this.clcenterx - this.clwidth / 2 - this.x) / this.imageScaleRatio);
            obj.y = Math.round((this.clcentery - this.clheight / 2 - this.y) / this.imageScaleRatio);
            obj.xCutSize = Math.round(this.clwidth / this.imageScaleRatio);
            obj.yCutSize = Math.round(this.clheight / this.imageScaleRatio);
            if (obj.xCutSize < 180 ) {
                obj.xCutSize = 180;
            }
            if (obj.yCutSize < 180 ) {
                obj.yCutSize = 180;
            }
            return obj;
        },
        chooseAnotherImage() {
            this.$emit('choose-another-image');
        },
        ok() {
            this.$emit('postFile', this.getFinalSize());
        }
    },
    mounted() {
        if (!window.requestAnimationFrame) {
            window.requestAnimationFrame = (fn) => {
                setTimeout(fn, 17);
            }
        }
        this.initContainer();

    }
}
</script>
<style scoped>
.avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 240px;
    height: 80px;
}
.avatar-uploader:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 240px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}
.avatar {
    width: 240px;
    height: 80px;
    display: block;
}
.preview-box {
    vertical-align: top;
}
.clip-container {
    display: inline-block;
    position: relative;
}
.clip-box {
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
}
.clip-box.top {
    top: 0;
    border-bottom: 1px dashed #fff;
}
.clip-box.bottom {
    bottom: 0;
    border-top: 1px dashed #fff;
}
.clip-box.left {
    left: 0;
    border-right: 1px dashed #fff;
}
.clip-box.right {
    right: 0;
    border-left: 1px dashed #fff;
}
.clip-box.top-right {
    top: 0;
    right: 0;
}
.clip-box.right-bottom {
    bottom: 0;
    right: 0;
}
.clip-box.bottom-left {
    bottom: 0;
    left: 0;
}
.clip-box.left-top {
    left: 0;
    top: 0;
}
.drag-dot {
    position: absolute;
    width: 8px;
    height: 8px;
    background: #fff;
}
.drag-dot.b-r, .drag-dot.t-l {
    cursor: nwse-resize;
}
.drag-dot.t-r, .drag-dot.b-l {
    cursor: nesw-resize;
}
.image-clip {
    user-select: none;
}
</style>




// WEBPACK FOOTER //
// src/components/Clip.vue